import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function PromiseSection() {
  return <section className="w-full bg-warm-dark py-20 md:py-28 relative overflow-hidden" data-id="element-135">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber/[0.03] rounded-full blur-[100px] pointer-events-none" data-id="element-136" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-138">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber/10 border border-amber/20 mb-8" data-id="element-139">
            <SparklesIcon className="w-6 h-6 text-amber" data-id="element-140" />
          </motion.div>

          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-8" data-id="element-141">
            Imagina tener una{' '}
            <span className="text-amber italic" data-id="element-142">guía clara y sencilla</span>
          </h2>

          <p className="font-body text-cream-muted/80 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-143">
            Ahora, imagina tener una guía clara y sencilla que te muestra, paso
            a paso, cómo levantar tu autoestima. Una hoja de ruta que te enseña
            a mejorar tu descanso, alimentarte de manera que potencie tu
            energía, dominar la ansiedad con técnicas de respiración y
            desarrollar nuevas habilidades que refuercen tu confianza.
          </p>
        </motion.div>
      </div>
    </section>;
}